import { RefObject, useEffect, useMemo, useState } from 'react';
import { ROWS_PER_PAGE, TOURNAMENT_TILE_MAX_WIDTH } from 'modules/tournaments/constants';

export function usePaginationLimit(
  ref: RefObject<HTMLDivElement | null>,
  tileMaxWidth = TOURNAMENT_TILE_MAX_WIDTH,
  rowsPerPage = ROWS_PER_PAGE
) {
  const [clientWidth, setClientWidth] = useState<number>(0);

  useEffect(() => {
    setClientWidth(ref.current?.clientWidth ?? 0);
  }, [setClientWidth, ref]);

  return useMemo(
    () => Math.floor(clientWidth / tileMaxWidth) * rowsPerPage,
    [clientWidth, rowsPerPage, tileMaxWidth]
  );
}
